var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoginBg = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "625px",
  height: "1200px",
  viewBox: "0 0 625 1200",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1BA785",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02B38A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0.193946678%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1BA785",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02B38A",
  offset: "100%"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-21"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#1BA785",
  x: 0,
  y: 0,
  width: 624.518119,
  height: 1199.07479
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L624.518119,0 C491.962066,20.2616911 402.9266,57.4542448 357.411719,111.577661 C269.671071,221.147059 312.259059,261.98816 205.928604,358.313295 C145.878195,401.31903 77.2353267,422.821897 0,422.821897 L0,0 Z",
  id: "Rectangle",
  fill: "url(#linearGradient-1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,777.178103 L624.518119,777.178103 C491.962066,797.439794 402.9266,834.632348 357.411719,888.755765 C269.671071,998.325162 312.259059,1039.16626 205.928604,1135.4914 C145.878195,1178.49713 77.2353267,1200 0,1200 L0,777.178103 Z",
  id: "Rectangle-Copy-3",
  fill: "url(#linearGradient-2)",
  transform: "translate(312.259059, 988.589052) scale(-1, -1) translate(-312.259059, -988.589052) "
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login_bg.e5bba2d6e13b28a345ff883b57ebf99e.svg";